import ProfessionalGuide from '../views/ProfessionalGuide.vue';
import GeneralProfessionalGuide from '../views/professional-guide/GeneralProfessionalGuide.vue';
import SingleProfessionalGuide from '../views/professional-guide/SingleProfessionalGuide.vue';

export default [
  {
    path: '/guia-profissionais',
    name: 'guia-profissionais',
    component: ProfessionalGuide,
    children: [
      {
        path: '/guia-profissionais/geral',
        name: 'guia-profissionais-geral',
        component: GeneralProfessionalGuide,
      },
      {
        path: '/guia-profissionais/profissional/:id',
        name: 'guia-profissionais-single',
        props: true,
        component: SingleProfessionalGuide,
      },
    ],
  },
];
